var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import TagsInput from 'react-tagsinput';
import { SoundsListHeader as SoundListHeader } from './index';
import { SoundListItem } from './index';
import { SoundDownloadContextConsumer } from '../../context/sounddownload';
import { DynamicPlaylist, AddToHistory, PlaybackManager, Loader, PlayerContextConsumer, SoundWrapper } from '../..';
import { SortByQueryOptions } from '../../api/types';
import { CHEVRON_LEFT_SVG, ELLIPSES_SVG, CHECKBOX_CHECKED_SVG, CHEVRON_DOWN_SVG } from '../../assets';
import { SoundDownloadManager } from '../../manager';
import { buildFilterFromArray, NoVisibibleSearchTerms, SoundListTags } from '../../util';
import { BPMSoundsGeneric } from '../../generic';
import { debounce } from 'lodash';
import { SoundListDragLayer } from './SoundListDragLayer';
import DragSelect from 'dragselect';
import { EditModeContext } from '../../context';
var SoundsList = /** @class */ (function (_super) {
    __extends(SoundsList, _super);
    function SoundsList(props) {
        var _this = _super.call(this, props) || this;
        _this.prevContext = _this.context;
        _this.ulContainer = null;
        _this.selectAll = function () {
            _this.props.sounds && SoundDownloadManager.getInstance().addSounds(_this.props.sounds);
        };
        _this.deselectAll = function () {
            _this.props.sounds && SoundDownloadManager.getInstance().removeSounds(_this.props.sounds);
        };
        _this.renderCheckbox = function () {
            return React.createElement(React.Fragment, null,
                React.createElement("label", { className: "checkbox" },
                    React.createElement(SoundDownloadContextConsumer, null, function (value) {
                        var _a;
                        var allSelected = ((_a = _this.props.sounds) === null || _a === void 0 ? void 0 : _a.find(function (s) {
                            return !value.includes(s.id);
                        })) == undefined;
                        return (React.createElement(React.Fragment, null,
                            React.createElement("img", { className: "checkbox-svg " + (allSelected ? '' : 'hidden'), src: CHECKBOX_CHECKED_SVG, alt: "checkbox" }),
                            React.createElement("input", { id: "box", type: "checkbox", onChangeCapture: function () {
                                    if (allSelected) {
                                        _this.deselectAll();
                                    }
                                    else {
                                        _this.selectAll();
                                    }
                                } }),
                            React.createElement("label", { htmlFor: "checkbox", className: "text", onClick: function () {
                                    if (allSelected) {
                                        _this.deselectAll();
                                    }
                                    else {
                                        _this.selectAll();
                                    }
                                } })));
                    })));
        };
        _this.renderArtwork = function () {
            return React.createElement(React.Fragment, null,
                React.createElement("div", { className: "artwork" }, "RELEASE"));
        };
        _this.renderPlayButton = function () {
            return React.createElement(React.Fragment, null,
                React.createElement("div", { className: "play-container" },
                    React.createElement("span", { className: "play-button" })));
        };
        _this.renderWaveform = function () {
            return React.createElement(React.Fragment, null,
                React.createElement("img", { className: "wave-form-container", style: { visibility: 'hidden' } }));
        };
        _this.renderSoundName = function () {
            return React.createElement(React.Fragment, null,
                React.createElement("div", { className: "name" },
                    React.createElement("span", { className: "name-inner" }, "NAME")));
        };
        _this.renderSoundTags = function () {
            return React.createElement(React.Fragment, null,
                React.createElement("div", { className: "button-container" }, "TAGS"));
        };
        _this.renderKeyBPMTime = function () {
            return React.createElement(React.Fragment, null,
                React.createElement("div", { className: "key-bpm-time-container" },
                    React.createElement("span", { className: "key" }, "KEY"),
                    React.createElement("span", { className: "bpm link", onClick: function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            if (_this.props.filter.sort_by == SortByQueryOptions.BPMDesc) {
                                _this.props.onFilterChange && _this.props.onFilterChange(__assign(__assign({}, _this.props.filter), { sort_by: SortByQueryOptions.BPMAsc }));
                            }
                            else if (_this.props.filter.sort_by == SortByQueryOptions.BPMAsc) {
                                _this.props.onFilterChange && _this.props.onFilterChange(__assign(__assign({}, _this.props.filter), { sort_by: undefined }));
                            }
                            else {
                                _this.props.onFilterChange && _this.props.onFilterChange(__assign(__assign({}, _this.props.filter), { sort_by: SortByQueryOptions.BPMDesc }));
                            }
                        } },
                        "BPM",
                        _this.props.filter.sort_by == SortByQueryOptions.BPMDesc && React.createElement("img", { className: "bpm-down", src: CHEVRON_DOWN_SVG, alt: "chevron" }),
                        _this.props.filter.sort_by == SortByQueryOptions.BPMAsc && React.createElement("img", { className: "bpm-up", src: CHEVRON_DOWN_SVG, alt: "chevron" })),
                    React.createElement("span", { className: "time" }, "TIME")));
        };
        _this.renderDownloadMidiIcon = function () {
            return React.createElement(React.Fragment, null,
                React.createElement("div", { className: "download-container" }));
        };
        _this.renderDownloadIcon = function () {
            return React.createElement(React.Fragment, null,
                React.createElement("div", { className: "download-container" }));
        };
        _this.renderSimilarIcon = function () {
            return React.createElement(React.Fragment, null,
                React.createElement("div", { className: "rings-container" }));
        };
        _this.renderHeartIcon = function () {
            return React.createElement(React.Fragment, null,
                React.createElement("div", { className: "heart-container" }));
        };
        _this.renderEllipsesIcon = function () {
            return React.createElement(React.Fragment, null,
                React.createElement("div", { className: "elipses sound-more-menu" }));
        };
        _this.state = {};
        _this.internallist = new DynamicPlaylist([], {
            history_mode: AddToHistory.ALL
        }, _this.props.context, false);
        _this.checkDivPosition = debounce(_this.checkDivPosition.bind(_this), 300);
        _this.toggleSimilarSound = _this.toggleSimilarSound.bind(_this);
        _this.refreshList = _this.refreshList.bind(_this);
        return _this;
    }
    Object.defineProperty(SoundsList.prototype, "currentPlaylist", {
        get: function () {
            return this.internallist;
        },
        enumerable: false,
        configurable: true
    });
    SoundsList.prototype.componentDidMount = function () {
        if (this.props.pagingMode !== 'manual' && this.props.pagingMode !== 'none') {
            window.addEventListener('scroll', this.checkDivPosition);
        }
    };
    SoundsList.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (this.props.sounds != prevProps.sounds) { // compare by reference
            this.buildPlaylist();
            PlaybackManager.getInstance().getContentManager().replaceLists(this.internallist);
            this.dragSelect && this.dragSelect.addSelectables(document.getElementsByClassName('list-item'));
        }
        if (this.context != this.prevContext) {
            this.prevContext = this.context;
            if (this.context) {
                this.dragSelect = new DragSelect({
                    selectables: document.getElementsByClassName('list-item'),
                    callback: function (e) {
                        var _a;
                        e.forEach(function (e) {
                            var _a;
                            if (e.dataset.soundId) {
                                var sound = (_a = _this.props.sounds) === null || _a === void 0 ? void 0 : _a.find(function (s) { return s.id == e.dataset.soundId; });
                                sound && SoundDownloadManager.getInstance().addSound(sound);
                            }
                        });
                        (_a = document.getSelection()) === null || _a === void 0 ? void 0 : _a.empty();
                        _this.dragSelect && _this.dragSelect.clearSelection(false);
                    }
                });
            }
            else {
                this.dragSelect && this.dragSelect.stop();
                this.dragSelect = undefined;
            }
        }
    };
    SoundsList.prototype.componentWillUnmount = function () {
        var track = PlaybackManager.getInstance().getTrack();
        if (this.internallist.tracks().find(function (t) { return t.sound.id == (track === null || track === void 0 ? void 0 : track.sound.id); }) && (track === null || track === void 0 ? void 0 : track.playlist.context) == this.internallist.context) {
            PlaybackManager.getInstance().getContentManager().clear();
        }
        SoundDownloadManager.getInstance().clear();
        window.removeEventListener('scroll', this.checkDivPosition);
    };
    SoundsList.prototype.buildPlaylist = function () {
        var _this = this;
        if (this.props.buildPlaylist) {
            this.internallist = this.props.buildPlaylist(this.internallist);
        }
        else {
            this.internallist.replace((this.props.sounds || []).map(function (sound) {
                return {
                    sound: sound,
                    playlist: _this.internallist
                };
            }));
        }
    };
    SoundsList.prototype.refreshList = function () {
        var _a = this.props, paging = _a.paging, loading = _a.loading, onLoadMore = _a.onLoadMore;
        if (!paging || !onLoadMore || loading) {
            return;
        }
        onLoadMore((paging.page) * paging.limited, true);
    };
    SoundsList.prototype.checkDivPosition = function () {
        if (this.loadMoreDiv) {
            var _a = this.props, paging = _a.paging, loading = _a.loading, onLoadMore = _a.onLoadMore;
            var hasMore = paging ? (paging.page * paging.limited) < paging.total : false;
            if (!hasMore || !onLoadMore || loading) {
                return;
            }
            var position = this.loadMoreDiv.getBoundingClientRect();
            if (position.top < window.innerHeight && position.bottom >= 0) {
                onLoadMore((paging.page + 1) * paging.limited);
            }
        }
    };
    SoundsList.prototype.toggleSimilarSound = function (sound) {
        var _this = this;
        var similar = this.state.similar;
        if (similar && similar.sound.id == sound.id) {
            this.setState({ similar: undefined });
        }
        else {
            this.setState({ similar: { sound: sound } });
            BPMSoundsGeneric.get().getSimilarSounds(sound).then(function (sounds) {
                // TODO: Alex
                if (_this.state.similar && _this.state.similar.sound.id == sound.id) {
                    _this.setState({ similar: { sound: sound, similarSounnds: sounds.data } });
                }
            });
        }
    };
    SoundsList.prototype.buildBPMStringIfNeeded = function (filter) {
        if (filter.bpm_max == undefined && filter.bpm_min == undefined) {
            return [];
        }
        if (filter.bpm_max == filter.bpm_min) {
            return ['bpm:' + filter.bpm_max];
        }
        if (filter.bpm_max != undefined && filter.bpm_max != 200) {
            if (filter.bpm_min) {
                return ['bpm_min:' + filter.bpm_min, 'bpm_max:' + filter.bpm_max];
            }
            return ['bpm_max:' + filter.bpm_max];
        }
        else if (filter.bpm_min) {
            return ['bpm_min:' + filter.bpm_min];
        }
        return [];
    };
    SoundsList.prototype.buildfilterString = function () {
        var _this = this;
        var filter = this.props.filter;
        if (!filter) {
            return '';
        }
        var keys = Object.keys(filter).filter(function (key) {
            if (key == 'search') {
                return filter['search'].trim() != '';
            }
            return !(NoVisibibleSearchTerms.concat(_this.props.hideFilterKeys || [])).includesLowercase(key) && filter[key] != undefined;
        });
        var value = keys.reduce(function (prev, key) {
            if (key.startsWith('bpm')) {
                return prev;
            }
            var value = filter[key];
            if (typeof value === 'boolean') {
                value = value ? 'yes' : 'no';
            }
            if (Array.isArray(value)) {
                value.forEach(function (value) {
                    prev.push(key + ": " + value.trim());
                });
            }
            else {
                prev.push(key + ": " + value.trim());
            }
            return prev;
        }, new Array()).concat(this.buildBPMStringIfNeeded(filter));
        return React.createElement(TagsInput, { value: value, onChange: function (values) {
                _this.props.onFilterChange && _this.props.onFilterChange(buildFilterFromArray(values, filter));
            }, renderInput: function () { return null; }, renderTag: function (props) {
                var tag = props.tag, key = props.key, disabled = props.disabled, onRemove = props.onRemove, classNameRemove = props.classNameRemove, getTagDisplayValue = props.getTagDisplayValue, other = __rest(props, ["tag", "key", "disabled", "onRemove", "classNameRemove", "getTagDisplayValue"]);
                var display = getTagDisplayValue(tag);
                var t = SoundListTags.find(function (suggestions) { return display.toLowerCase().startsWith(suggestions.name); });
                if (t) {
                    return (React.createElement("span", { key: key },
                        React.createElement("span", { className: 'tag-key' }, t.display || t.name),
                        React.createElement("span", __assign({}, other),
                            React.createElement("span", { className: "tag-name", onClick: function (e) { return onRemove(key); } },
                                " ",
                                display.substr(t.name.length),
                                !disabled &&
                                    React.createElement("a", { className: classNameRemove, onClick: function (e) { return onRemove(key); } })))));
                }
                return (React.createElement("span", __assign({ key: key }, other),
                    display,
                    !disabled &&
                        React.createElement("a", { className: classNameRemove, onClick: function (e) { return onRemove(key); } })));
            }, renderLayout: function (tagComponents, inputComponent) {
                return React.createElement("div", { style: { display: 'flex', alignItems: 'center', height: '3rem' } },
                    tagComponents,
                    inputComponent);
            } });
    };
    SoundsList.prototype.calculatePagination = function (current, last, moreSymbol) {
        var delta = 1, left = current - delta, right = current + delta + 5, range = [], rangeWithDots = [], l;
        for (var i = 1; i <= last; i++) {
            if (i == 1 || i == last || i >= left && i < right) {
                range.push(i);
            }
        }
        for (var _i = 0, range_1 = range; _i < range_1.length; _i++) {
            var i = range_1[_i];
            if (l) {
                if (i - l === 2) {
                    rangeWithDots.push(l + 1);
                }
                else if (i - l !== 1) {
                    rangeWithDots.push(moreSymbol);
                }
            }
            rangeWithDots.push(i);
            l = i;
        }
        return rangeWithDots;
    };
    SoundsList.prototype.renderHeader = function () {
        return React.createElement(SoundListHeader, __assign({}, this.props, { search: this.props.filter.search }));
    };
    SoundsList.prototype.renderFilter = function () {
        return React.createElement("div", { className: 'info filter' }, this.buildfilterString());
    };
    SoundsList.prototype.renderAutoLoadMore = function () {
        var _this = this;
        var _a = this.props, paging = _a.paging, loading = _a.loading, onLoadMore = _a.onLoadMore, sounds = _a.sounds;
        var hasMore = paging ? (paging.page * paging.limited) < paging.total : false;
        if (!hasMore || !onLoadMore || loading) {
            if ((sounds === null || sounds === void 0 ? void 0 : sounds.length) == 0)
                return null;
            return React.createElement("div", { className: "end-text", style: !hasMore && !loading ? {} : { display: 'none' } }, "End of List");
        }
        return React.createElement("div", { ref: function (ref) { return _this.loadMoreDiv = ref; } });
    };
    SoundsList.prototype.renderManualLoadMore = function () {
        var _this = this;
        var _a = this.props, paging = _a.paging, loading = _a.loading;
        var hasMore = paging ? true : false;
        if (!hasMore || !this.props.onLoadMore || loading) {
            return null;
        }
        var onLoadMore = function (limitOrPage, force, paged) {
            var _a, _b;
            _this.props.onLoadMore(limitOrPage, force, paged);
            var elem = document.getElementsByClassName('sticky-target').item(0);
            if (elem && elem.getBoundingClientRect().top < 0) {
                var top_1 = (((_a = document.scrollingElement) === null || _a === void 0 ? void 0 : _a.scrollTop) || 0) + elem.getBoundingClientRect().top - window.getStickyAndHeaderHeight();
                (_b = document.scrollingElement) === null || _b === void 0 ? void 0 : _b.scrollTo({
                    top: top_1
                });
            }
        };
        var moreSymbol = Symbol('More');
        var endNumber = Math.ceil(paging.total / paging.limited);
        if (endNumber == 0) {
            return;
        }
        var current = paging.page;
        var paginationArray = endNumber != 1 ? this.calculatePagination(current, endNumber, moreSymbol) : [];
        if (paginationArray.length == 0) {
            return React.createElement("div", { className: "end-text" }, "End of List");
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("ul", { className: 'pagination' },
                React.createElement("li", { className: "prev-chevron " + (current === 1 ? 'disabled' : ''), onClick: function () { return onLoadMore(1, true, true); } },
                    React.createElement("img", { "aria-hidden": "true", src: CHEVRON_LEFT_SVG, alt: "" })),
                React.createElement("li", { className: "prev " + (current === 1 ? 'disabled' : ''), onClick: function () { return onLoadMore(Math.max(paging.page - 1, 1), true, true); } },
                    React.createElement("span", { "aria-hidden": "true" }, "PREV")),
                paginationArray.map(function (item, index) {
                    return React.createElement("li", { key: index, className: (item != moreSymbol && item == current) ? 'selected' : ((item == moreSymbol) ? 'more' : 'number'), onClick: item == moreSymbol ? undefined : (function () { return onLoadMore(item, true, true); }) }, item === moreSymbol
                        ? React.createElement("img", { src: ELLIPSES_SVG, alt: "" })
                        : React.createElement("span", null, item));
                }),
                React.createElement("li", { className: "next " + (current === endNumber ? 'disabled' : ''), onClick: function () { return onLoadMore(Math.min(paging.page + 1, endNumber), true, true); } },
                    React.createElement("span", { "aria-hidden": "true" }, "NEXT")),
                React.createElement("li", { className: "next-chevron " + (current === endNumber ? 'disabled' : ''), onClick: function () { return onLoadMore(endNumber, true, true); } },
                    React.createElement("img", { "aria-hidden": "true", src: CHEVRON_LEFT_SVG, alt: "" }))),
            React.createElement("div", { className: "go-to" },
                React.createElement("span", { className: "go-text" }, "Go to page"),
                React.createElement("input", { className: "go-input", type: "input", onKeyPress: function (event) {
                        if (event.which < 48 || event.which > 57) {
                            event.preventDefault();
                        }
                    }, onKeyUp: function (event) {
                        var input = event.currentTarget.value;
                        if (event.key === 'Enter'
                            && input.trim().length > 0
                            && !isNaN(parseInt(input))) {
                            onLoadMore(parseInt(event.currentTarget.value), true, true);
                        }
                    } }))));
    };
    SoundsList.prototype.renderSimilarSounds = function (forSound) {
        var similar = this.state.similar;
        if (similar && similar.sound.id == forSound.id) {
            return React.createElement("div", { className: 'similar-sounds' },
                React.createElement("div", { className: 'similar-sounds-description' }, "Similar Sounds"),
                similar.similarSounnds && similar.similarSounnds.length === 0 ?
                    React.createElement("div", { className: "no-similar" }, "No Similar Sounds Found")
                    :
                        React.createElement(SoundsList, __assign({}, this.props, { pagingMode: 'none', isSimilarList: true, sounds: similar.similarSounnds, loading: similar.similarSounnds == undefined })));
        }
        return null;
    };
    SoundsList.prototype.renderList = function (loading, sounds) {
        var _this = this;
        var isSimilarList = this.props.isSimilarList;
        return React.createElement(PlayerContextConsumer, null, function (playerContext) {
            var _a;
            return React.createElement(React.Fragment, null,
                React.createElement("ul", { ref: function (ref) { return _this.ulContainer = ref; }, className: 'allow-hover' },
                    sounds != undefined && !isSimilarList && React.createElement("div", { className: 'list-item-container' },
                        React.createElement("li", { className: "list-item header no-select" }, (_a = _this.props.listItemRenderer) === null || _a === void 0 ? void 0 :
                            _a.listItemHeaderRenderer(playerContext, {
                                renderCheckbox: _this.renderCheckbox,
                                renderArtwork: _this.renderArtwork,
                                renderPlayButton: _this.renderPlayButton,
                                renderSoundName: _this.renderSoundName,
                                renderWaveform: _this.renderWaveform,
                                renderSoundTags: _this.renderSoundTags,
                                renderKeyBPMTime: _this.renderKeyBPMTime,
                                renderDownloadMidiIcon: _this.renderDownloadMidiIcon,
                                renderDownloadIcon: _this.renderDownloadIcon,
                                renderSimilarIcon: _this.renderSimilarIcon,
                                renderHeartIcon: _this.renderHeartIcon,
                                renderEllipsesIcon: _this.renderEllipsesIcon,
                            }),
                            !_this.props.listItemRenderer && React.createElement(React.Fragment, null,
                                _this.renderCheckbox(),
                                _this.renderArtwork(),
                                _this.renderPlayButton(),
                                _this.renderWaveform(),
                                _this.renderSoundName(),
                                _this.renderSoundTags(),
                                _this.renderKeyBPMTime(),
                                React.createElement("div", { className: "icons-container" },
                                    _this.renderDownloadMidiIcon(),
                                    _this.renderDownloadIcon(),
                                    _this.renderSimilarIcon(),
                                    _this.renderHeartIcon(),
                                    _this.renderEllipsesIcon())))),
                    React.createElement(SoundListDragLayer, null),
                    sounds != undefined && sounds.map(function (sound) {
                        return React.createElement(SoundWrapper, { key: sound.id, sound: sound }, function (sound) {
                            var _a, _b;
                            return React.createElement("div", { key: sound.id, className: 'list-item-container' },
                                React.createElement(SoundListItem, __assign({}, _this.props, { key: sound.id, sound: sound, renderListItem: (_a = _this.props.listItemRenderer) === null || _a === void 0 ? void 0 : _a.listItemRenderer, renderExpandedItem: (_b = _this.props.listItemRenderer) === null || _b === void 0 ? void 0 : _b.listItemExpandedItemRenderer, refreshList: _this.refreshList, similar: _this.state.similar, playList: _this.internallist, toggleSimilarSound: _this.toggleSimilarSound, parentContainer: _this.ulContainer, onItemExpand: _this.props.onItemExpand })),
                                _this.renderSimilarSounds(sound));
                        });
                    }),
                    loading && React.createElement(Loader, { centered: true, style: {
                            marginTop: 20
                        }, size: '3rem' })));
        });
    };
    SoundsList.prototype.render = function () {
        var _this = this;
        var _a = this.props, sounds = _a.sounds, emptyPlaceholder = _a.emptyPlaceholder, isSimilarList = _a.isSimilarList, pagingMode = _a.pagingMode, loading = _a.loading;
        return (React.createElement("div", { className: "SoundsList container" },
            !isSimilarList && this.renderFilter(),
            (function () {
                if (sounds) {
                    if (sounds.length === 0 && !emptyPlaceholder) {
                        return React.createElement("div", { className: "no-packs" }, "No Sounds Available");
                    }
                    else if (sounds.length === 0 && emptyPlaceholder) {
                        return React.createElement("div", { className: "no-packs" }, emptyPlaceholder);
                    }
                    else {
                        return (_this.renderList(loading, sounds));
                    }
                }
                return null;
            })(),
            pagingMode == 'none' ? null :
                (pagingMode === 'manual'
                    ? this.renderManualLoadMore()
                    : this.renderAutoLoadMore())));
    };
    SoundsList.contextType = EditModeContext;
    return SoundsList;
}(React.Component));
export default SoundsList;
//# sourceMappingURL=SoundsList.js.map